// extracted by mini-css-extract-plugin
module.exports = {"EditorChoice":"EditorChoice_EditorChoice__2jtz9","EditorChoicePrimary":"EditorChoice_EditorChoicePrimary__15thI","starIcon":"EditorChoice_starIcon__1zTN1"};